import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { UntypedFormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommunicationsService, OrderService } from '@app/_services';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '@app/_services/authentication.service';
import { QuotationCartService } from '@app/_services/quotation.service';
import { FormDataHelper } from '@app/_helpers';
 import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatGridListModule } from '@angular/material/grid-list';
import { FlexModule } from '@angular/flex-layout/flex';
import { NgFor, NgIf, DatePipe } from '@angular/common';
import { ImageModalComponent } from '@app/_components/image_modal/image-modal.component';

@Component({
    selector: 'app-order-messages',
    templateUrl: './order-messages.component.html',
    styleUrls: ['./order-messages.component.scss'],
    providers: [FormDataHelper, BsModalRef],
    standalone: true,
    imports: [NgFor, NgIf, FlexModule, MatGridListModule, MatIconModule, FormsModule, ReactiveFormsModule, MatButtonModule, DatePipe, TranslateModule]
})
export class OrderMessageComponent implements OnInit {
    userId: any;

    constructor(
        private fb: UntypedFormBuilder,
        private ordersService: OrderService,
        private toastr: ToastrService,
        private auth: AuthenticationService,
        private fd: FormDataHelper,
        public bsModalRef: BsModalRef,
        private modalService: BsModalService,
        ) { }

    @Input() order

    files: any[] = [];
    file: any;
    url;
    @Output() public getImageData = new EventEmitter<any>();
    @Output() public deleteImageKey = new EventEmitter<any>();

    form = this.fb.group({
        message: [null, [Validators.required]],
        images: []
    })

    ngOnInit(): void {
    }

    /**
     * handle file from browsing
     */
    fileBrowseHandler(files) {
        this.prepareFilesList(files);
    }


    /**
     * Convert Files list to normal array list
     * @param files (Files List)
     */
    prepareFilesList(files: Array<any>) {
        for (const item of files) {
            this.url = null;
            item.progress = 0;
            const reader = new FileReader();
            reader.onload = () => {
                item.url = reader.result as string;
            }
            reader.readAsDataURL(item)
            this.files.push(item);
            this.getImageData.emit(this.files);
        }
        this.form.get('images').patchValue(Array.from(files));
    }

 /*    deleteImage(key){
        this.deleteImageKey.emit(key);
    }
 */
    deleteImageAt(index){
        this.files.splice(index, 1);
        this.form.get('images').patchValue(Array.from(this.files));
    }

  show(url)
  {
     let initialState =
      {
        imgSrc : url
      }
    this.bsModalRef = this.modalService.show(ImageModalComponent, { initialState, class: 'modal-lg image-quote' });
  }

    send() {

        if (!this.form.get('message').value?.trim()?.length && !this.form.get('images').value?.length) return this.toastr.error('Fill In Required Fields');

        let msgData = new FormData();
        msgData = this.fd.ToFormData(this.form.value);

        this.ordersService.addCommunication(this.order.orderId, msgData).subscribe((success: any) => {
            if (success.code == 200) {
                this.toastr.success('Message Sent');

                this.order = success.data;

            this.form.reset();
            this.files = [];
            } else {
                this.toastr.success(success.msg);
            }
        }, (error) => {
            //console.log(error)
        })

    }

}
